import React, {useState} from 'react';
import gql from 'graphql-tag';
import {Mutation} from 'react-apollo';
import ConfirmModal from '../app/ConfirmModal';

const DELETE_PRODUCT_STATE = gql`
  mutation deleteProductState($id: Int!) {
    deleteProductState(id: $id)
  }
`;

const DeleteProductState = ({id, refetch}) => {
  const [showModal, setShowModal] = useState(false);
  return (
    <Mutation mutation={DELETE_PRODUCT_STATE} variables={{id}} onCompleted={refetch}>
      {deleteProductState => (
        <>
          <ConfirmModal
            isVisible={showModal}
            confirm={() => {
              deleteProductState(id);
              setShowModal(false);
            }}
            cancel={() => setShowModal(false)}
            question={
              'DATENSATZ LÖSCHEN! Damit wird dieser Datensatz unwiderruflich vollständig gelöscht! Sind Sie sich sicher?'
            }
          />
          <span
            role="img"
            aria-label="löschen"
            onClick={e => {
              setShowModal(true);
              e.preventDefault();
              e.stopPropagation();
            }}>
            ❌
          </span>
        </>
      )}
    </Mutation>
  );
};
export default DeleteProductState;
